import { render, staticRenderFns } from "./product-kit-components.vue?vue&type=template&id=4ef7dff3"
import script from "./product-kit-components.vue?vue&type=script&lang=js"
export * from "./product-kit-components.vue?vue&type=script&lang=js"
import style0 from "./product-kit-components.vue?vue&type=style&index=0&id=4ef7dff3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports